/* eslint-disable react/jsx-one-expression-per-line */
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { FaDownload } from 'react-icons/fa';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import TableList from '~/components/tableList';
import { TitleCategory } from '~/views/Consult/User/Detail/styles';
import FilterBenefit from './components/FilterBenefit';
import { useReportBenefit } from './context/useBenefit';
import { runPaginatedDownloadTask } from '~/utils/runPaginatedDownloadTask';
import Models from '../models';

import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import ResultNotFound from '~/components/resultNotFound';
import * as S from './styles';
const getPayloadType = (form) => {
  const dataInicial = moment(form.periodoInicial, 'DD/MM/YYYY').format(
    'YYYY-MM-DD',
  );
  const dataFinal = moment(form.periodoFinal, 'DD/MM/YYYY').format(
    'YYYY-MM-DD',
  );
  return {
    VENDAS_ODONTO: {
      dataFinal,
      dataInicial,
      idOperador: form.idAtendente,
      statusCartao: form.statusCartao,
      uf: form.uf,
    },
    CANCELAMENTO_ODONTO: {
      dataFinal,
      dataInicial,
      idOperador: form.idAtendente,
      statusCartao: form.statusCartao,
      tipoPeriodo: form.tipoPeriodoCancelamentoOdonto,
      uf: form.uf,
    },
    FATURAMENTO_ODONTO: {
      periodoInicial: dataInicial,
      periodoFinal: dataFinal,
      periodoFaturamentoOdonto: form.periodoFaturamentoOdonto,
    },
    VENDAS_PROTEGE: {
      dataFinal,
      dataInicial,
      operador: form.idAtendente,
      tipoSeguro: form.tipoSeguro,
      uf: form.uf,
    },
    CANCELAMENTO_PROTEGE: {
      dataFinal,
      dataInicial,
      idOperador: form.idAtendente,
      statusCartao: form.statusCartao,
      tipoPeriodo: form.tipoPeriodoCancelamentoProtege,
      uf: form.uf,
    },
    VENDAS_CUIDA: {
      dataInicial,
      dataFinal,
      operador: form.idAtendente,
      uf: form.uf,
      statusCartao: form.statusCartao,
    },
    CANCELAMENTO_CUIDA: {
      dataFinal,
      dataInicial,
      operador: form.idAtendente,
      tipoPeriodo: form.tipoPeriodoCancelamentoCuida,
      uf: form.uf,
    },
    VENDAS_PLATINUM: {
      dataAdesaoFinal: dataFinal,
      dataAdesaoInicial: dataInicial,
      operador: form.idAtendente,
      tipoAdesao: form.tipoAdesao,
    },
    CANCELAMENTO_PLATINUM: {
      dataFinal,
      dataInicial,
      operador: form.idAtendente,
      tipoData: form.periodoCancelamentoPlatinum,
      uf: form.uf,
    },
    LIMIT_EXTRA_12X: {
      dataFim: dataFinal,
      dataInicio: dataInicial,
      operadorContratacao: form.operadorContratacao,

      status: form.status,
    },
  };
};

const getResponseItems = (response: any) => {
  if (!response) {
    return { items: [], totalPages: 1 };
  }

  if (Array.isArray(response)) {
    return { items: response, totalPages: 1 };
  }

  const totalPages = response.totalDePaginas || response.totalPaginas || 1;
  const items = response.pagina || response.data || response.vendas || [];

  return { items, totalPages };
};

const getCsvData = (tipoBeneficio: string, items: any[]) => {
  switch (tipoBeneficio) {
    case 'VENDAS_ODONTO':
      return Models.BodyReportOdontoCSV(items);
    case 'CANCELAMENTO_ODONTO':
      return Models.BodyReportCancelOdontoCSV(items);
    case 'VENDAS_PROTEGE':
      return Models.BodyTeucardProtegeCSV(items);
    case 'CANCELAMENTO_PROTEGE':
      return Models.BodyReportCancelSafeCSV(items);
    case 'VENDAS_CUIDA':
      return Models.BodyReportCuidaCSV(items);
    case 'CANCELAMENTO_CUIDA':
      return Models.BodyReportCancelCuidaCSV(items);
    case 'VENDAS_PLATINUM':
      return Models.BodyUpgradePlatinumCardCSV(items);
    case 'CANCELAMENTO_PLATINUM':
      return Models.BodyReportCancellationPlatinumCSV(items);
    default:
      return items;
  }
};

const ReportBenefit: React.FC = () => {
  const refCSV = useRef<any>(null);
  const [downloadCVSProgress, setDownloadCVSProgress] = useState('');
  const [error, setError] = useState<string | null>();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  const {
    postReportInvoceOdont,
    postReportCancelOdont,
    postReportCancelSafe,
    postReportSalesOdont,
    postReportSalesSafe,
    postReportSalesCuida,
    postReportCancelCuida,
    postReportSalesPlatinumCard,
    postReportCancellationPlatinum,
    getReportExtraInstallment,
    onClickDownloadFileInstallmentsCSV,
    getOperador,
    items,
    totalItems,
    totalPages,
    headerItems,
    header,
    relatorioData,
    setRelatorioData,
    clearForm,
    resetForm,
    checkSuccess,
    loading,
    operador,
    form,
    setForm,
  } = useReportBenefit();

  useEffect(() => {
    getOperador();
  }, []);

  const getReport = async (page = 1) => {
    const payload = getPayloadType(form)[form.tipoBeneficio.value];
    if (page === 1) clearForm();

    switch (form.tipoBeneficio?.value) {
      case 'VENDAS_ODONTO':
        await postReportSalesOdont(page, 30, false, payload);
        break;
      case 'CANCELAMENTO_ODONTO':
        await postReportCancelOdont(page, 30, false, payload);
        break;
      case 'FATURAMENTO_ODONTO':
        await postReportInvoceOdont(page, 30, false, payload);
        break;
      case 'VENDAS_PROTEGE':
        await postReportSalesSafe(page, 30, false, payload);
        break;
      case 'CANCELAMENTO_PROTEGE':
        await postReportCancelSafe(page, 30, false, payload);
        break;
      case 'VENDAS_CUIDA':
        await postReportSalesCuida(page, 30, false, payload);
        break;
      case 'CANCELAMENTO_CUIDA':
        await postReportCancelCuida(page, 30, false, payload);
        break;
      case 'VENDAS_PLATINUM':
        await postReportSalesPlatinumCard(page, 30, false, payload);
        break;
      case 'CANCELAMENTO_PLATINUM':
        await postReportCancellationPlatinum(page, 30, false, payload);
        break;
      case 'LIMIT_EXTRA_12X':
        await getReportExtraInstallment(page, 30, false, payload);
        break;
      default:
        break;
    }
  };

  const onClickDownloadCSV = async (
    currentPage = 1,
    accumulatedData: any[] = [],
  ) =>
    runPaginatedDownloadTask(currentPage, async () => {
    let response;

    if (currentPage === 1) {
      setDownloadCVSProgress('0%');
    }
    const payload = getPayloadType(form)[form?.tipoBeneficio?.value];

    switch (form.tipoBeneficio?.value) {
      case 'VENDAS_ODONTO':
        response = await postReportSalesOdont(currentPage, 150, true, payload);
        break;
      case 'CANCELAMENTO_ODONTO':
        response = await postReportCancelOdont(currentPage, 150, true, payload);
        break;
      case 'FATURAMENTO_ODONTO':
        response = await postReportInvoceOdont(currentPage, 100, true, payload);
        break;
      case 'VENDAS_PROTEGE':
        response = await postReportSalesSafe(currentPage, 150, true, payload);
        break;
      case 'CANCELAMENTO_PROTEGE':
        response = await postReportCancelSafe(currentPage, 150, true, payload);
        break;
      case 'VENDAS_CUIDA':
        response = await postReportSalesCuida(currentPage, 150, true, payload);
        break;
      case 'CANCELAMENTO_CUIDA':
        response = await postReportCancelCuida(currentPage, 150, true, payload);
        break;
      case 'VENDAS_PLATINUM':
        response = await postReportSalesPlatinumCard(
          currentPage,
          150,
          true,
          payload,
        );
        break;
      case 'CANCELAMENTO_PLATINUM':
        response = await postReportCancellationPlatinum(
          currentPage,
          150,
          true,
          payload,
        );
        break;
      default:
        break;
    }

    if (response) {
      const { items, totalPages } = getResponseItems(response);
      const percentage = (currentPage / totalPages) * 100;
      const roundPercentage = Math.ceil(percentage);

      setDownloadCVSProgress(`${roundPercentage || 0}%`);

      if (items.length) {
        const csvData = getCsvData(form.tipoBeneficio?.value, items);
        const existingCpfs = accumulatedData.map((item) => item.cpf);
        const filteredData = csvData.filter(
          (item) => !existingCpfs.includes(item.cpf),
        );
        const newAccumulated = [...accumulatedData, ...filteredData];

        if (currentPage < totalPages) {
          return onClickDownloadCSV(currentPage + 1, newAccumulated);
        }

        setRelatorioData(newAccumulated);
        setDownloadCVSProgress('');
        return newAccumulated;
      }

      if (currentPage < totalPages) {
        return onClickDownloadCSV(currentPage + 1, accumulatedData);
      }
    }

    setDownloadCVSProgress('');
    setRelatorioData(accumulatedData);
    return accumulatedData;
    });

  useEffect(() => {
    clearForm();
    return () => {
      resetForm();
    };
  }, []);

  return (
    <>
      <Dialog
        icon={icons.exclamation}
        open={dialogIsOpen}
        positiveLabel="Entendi"
        positiveAction={() => setDialogIsOpen(false)}
        message={error}
      />
      <Loading status={loading} />
      <Container>
        <FilterBenefit
          operador={operador || []}
          onSubmit={(e) => {
            getReport();
          }}
        />

        <CSVLink
          ref={refCSV}
          data={relatorioData}
          style={{
            color: 'inherit',
            textDecoration: 'none',
          }}
          headers={header}
          filename={`relatorio_beneficio_${form.tipoBeneficio.value}.csv`}
          target="_blank"
        />

        {items?.length > 0 ? (
          <S.BoxCard>
            <ContainerFlex flex="0.2">
              <ContainerFlex row space center marginBottom={24}>
                <S.BoxCardTitle>Relatório</S.BoxCardTitle>

                <Button
                  onClick={() => {
                    if (form.tipoBeneficio.value === 'LIMIT_EXTRA_12X') {
                      onClickDownloadFileInstallmentsCSV((message) => {
                        setDialogIsOpen(true);
                        setError(message);
                      });
                    } else if (refCSV.current) {
                      onClickDownloadCSV().then((csvData) => {
                        if (!csvData?.length) return;

                        setTimeout(() => {
                          refCSV.current?.link?.click();
                        }, 0);
                      });
                    }
                  }}
                  disabled={loading}
                >
                  <FaDownload />
                  <span style={{ marginLeft: 8 }}>Download</span>
                </Button>
              </ContainerFlex>

              <ContainerFlex>
                <TableList customerHeader={headerItems} list={items} />
                <ContainerFlex row space center marginTop={20}>
                  <ContainerFlex>
                    <S.ShowResults>
                      Total de resultados: <strong>{totalItems}</strong>
                    </S.ShowResults>
                  </ContainerFlex>
                  {form?.tipoBeneficio?.value !== 'VENDAS_ODONTO' &&
                    form?.tipoBeneficio?.value !== 'CANCELAMENTO_ODONTO' &&
                    form?.tipoBeneficio?.value !== 'VENDAS_PROTEGE' &&
                    form.tipoBeneficio?.value !== 'CANCELAMENTO_PROTEGE' &&
                    form.tipoBeneficio?.value !== 'VENDAS_CUIDA' &&
                    form?.tipoBeneficio?.value !== 'CANCELAMENTO_CUIDA' &&
                    form?.tipoBeneficio?.value !== 'CANCELAMENTO_PLATINUM' && (
                      <Pagination
                        totalPages={totalPages}
                        onCurrentPageChange={getReport}
                      />
                    )}
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
          </S.BoxCard>
        ) : (
          <ResultNotFound />
        )}
        {checkSuccess() && items.length <= 0 && (
          <ContainerFlex center>
            <TitleCategory>Nenhum resultado encontrado</TitleCategory>
          </ContainerFlex>
        )}
      </Container>
    </>
  );
};

export default ReportBenefit;
